export const INACTIVE_STATUSES = ['EXPIRED', 'CANCELLED', 'SOLD', 'WITHDRAWN'];
export const STREET_VIEW_STYLE = 'mapbox://styles/mapbox/streets-v12';
export const SATELLITE_VIEW_STYLE =
  'mapbox://styles/mapbox/satellite-streets-v12';
export const REIX_BLUE = '#3D00F4';
export const LIST_PRICE = 'List Price';
export const LAST_LIST_PRICE = 'Last List Price';
export const SOLD_PRICE = 'Sold Price';
export const NA = 'N/A';
